/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class SimpleUserRequest {
    'id': number;
    'name'?: string;
    'avatar'?: HttpFile;
    'role'?: string;
    'aThumbnail'?: string;
    'country'?: string;
    'sportfengurId'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "avatar",
            "baseName": "avatar",
            "type": "HttpFile",
            "format": "binary"
        },
        {
            "name": "role",
            "baseName": "role",
            "type": "string",
            "format": ""
        },
        {
            "name": "aThumbnail",
            "baseName": "aThumbnail",
            "type": "string",
            "format": ""
        },
        {
            "name": "country",
            "baseName": "country",
            "type": "string",
            "format": ""
        },
        {
            "name": "sportfengurId",
            "baseName": "sportfengurId",
            "type": "number",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return SimpleUserRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

